import EventEmitter from 'events'
import WalletConnectProvider from '@walletconnect/web3-provider'
import { INFURA_ID } from '~utils/ethereum'

class MetamaskAdapter {
    connector

    provider

    eventEmitter

    connected

    accounts

    chainId

    constructor() {
        this.provider = new WalletConnectProvider({
            infuraId: INFURA_ID,
        })
        this.emitter = new EventEmitter()

        this.onAccountsChanged = this.onAccountsChanged.bind(this)
        this.onChainChanged = this.onChainChanged.bind(this)
        this.onDisconnect = this.onDisconnect.bind(this)
    }

    async connect() {
        try {
            this.accounts = await this.provider.enable()
            this.chainId = this.provider.chainId

            this.provider.on('accountsChanged', this.onAccountsChanged)
            this.provider.on('chainChanged', this.onChainChanged)
            this.provider.on('error', this.onDisconnect)
            this.provider.on('disconnect', this.onDisconnect)

            this.connected = true
        } catch (e) {
            this.emitter.emit('disconnected')

            throw e
        }

        return this.accounts
    }

    getAccounts() {
        return this.accounts || []
    }

    getChainId() {
        return this.chainId
    }

    isConnected() {
        return this.connected
    }

    getProvider() {
        return this.provider
    }

    // eslint-disable-next-line class-methods-use-this
    canWatchAsset() {
        return false
    }

    on(...args) {
        this.emitter.on(...args)
    }

    off(...args) {
        this.emitter.removeListener(...args)
    }

    onDisconnect() {
        this.emitter.emit('disconnected')
    }

    onAccountsChanged(accounts) {
        this.accounts = accounts

        if (!accounts || accounts.length <= 0) {
            this.emitter.emit('disconnected')
        } else {
            this.emitter.emit('accountsChanged', accounts)
        }
    }

    onChainChanged(chainId) {
        this.chainId = chainId

        this.emitter.emit('chainChanged', chainId)
    }

    disconnect() {
        this.connected = false

        if (this.provider) {
            // this.provider.disconnect()
            this.provider.off('accountsChanged', this.onAccountsChanged)
            this.provider.off('chainChanged', this.onChainChanged)
            this.provider.off('error', this.onDisconnect)
            this.provider.off('disconnect', this.onDisconnect)
        }

        this.emitter.removeAllListeners()
    }
}

export default MetamaskAdapter
